interface SpinnerProps {
  className?: string;
  size?: 'sm' | 'lg';
  disabled?: boolean;
}

const Spinner = ({
  className,
  size = 'lg',
  disabled = false
}: SpinnerProps) => {
  const spinnerStyles = `
    m-auto rounded-full border-cofeeNeutralInactive
    ${disabled ? '' : 'animate-spin border-t-primary'} 
  `.trim();

  return (
    <div
      className={`${spinnerStyles} ${className || ''} ${
        size === 'sm' ? 'size-4 border-2' : 'size-12 border-4'
      }`}
    />
  );
};

export default Spinner;
